import React from 'react';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames';
import Select from 'react-select';

import { addGeoJson, removeLocation } from 'bundles/connect/components/store/actions/criteria';
import { REGIONS } from 'bundles/connect/constants';
import { selectLocationAttributes } from 'bundles/connect/components/store/selectors/criteria';

type RegionInputProps = {
  removeLocation: (id: string) => void;
  addGeoJson: (geoJson: {
    type: string;
    label: string;
    coordinates: number[][][]
  }, properties: {
    name: string;
  }) => void;
}

function RegionInput({
  removeLocation,
  addGeoJson
}: RegionInputProps) {
  const locationsAttributes = useSelector(selectLocationAttributes);

  const regionSelected = (e) => {
    const selectedRegion = e.length > locationsAttributes.length ? e[e.length - 1] : null;
    if (selectedRegion) {
      const region = REGIONS.find(region => region.label === selectedRegion?.value);
      region && addGeoJson(region, { name: region.label });
    } else {
      const selectedRegions = e.map(item => item.value);
      const locations = locationsAttributes.filter(location => !selectedRegions.includes(location.name));
      locations.forEach((location) => {
        removeLocation(location.id || '');
      });
    }
  };

  const selectValue = () => {
    return locationsAttributes.map(location => ({
      label: location.name,
      value: location.name
    }));
  };

  return (
    <Select
      className={classNames('as-button', locationsAttributes.length > 0 ? 'active' : 'text-muted')}
      isClearable
      isMulti
      menuPlacement="auto"
      options={
        REGIONS.map(region => ({
          label: region.label,
          value: region.label
        }))
      }
      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      value={selectValue()}
      onChange={e => regionSelected(e)}
    />
  );
}

export default connect(undefined, { addGeoJson, removeLocation })(RegionInput);
